import audio from '../../../../assets/audio/kids-tracks/Text24.mp3';
import path from '../../../../assets/images/games/zdar-kids-game/to-tree.webp';

export const step33church = {
    id: 33,
    title: 'Rozcestí',
    taskText: `
        <p>
            „Hmm, tak teď moc nevím kudy kam, ale zkusila bych ten obří strom v poli. Schází se tam spousta koček z okolí a 
            slyšela jsem, že tam vídají nějakého ducha, tak to můžete okouknout.“ 
        </p>
        <p>
            „Moc díky Lindo, pomohla jsi nám”
        </p>
        <p>
            Pojďme se tedy vydat ke stromu, který Linda zmiňuje. Než se ale vydáme na cestu, je potřeba se pořádně rozcvičit. Udělejme si 10 dřepů.
        </p>
    `,
    cipher: {
        images: [path],
        label: 'Úkol',
    },
    continueButtonText: 'Jsme u stromu',
    points: true,
    audio: audio,
};
